<div class="row">
  <div class="col-6">
    <strong>{{ "Template.StatusComponent.text_dataUploaded" | translate }}:</strong>
  </div>
  @if (dataCatalogStatus) {
    <div class="col-6">
      @if (dataCatalogStatus?.status != 'PRISTINE') {
        <fa-icon icon="check" class="text-success"></fa-icon>
      }
      @if (!dataCatalogStatus || dataCatalogStatus?.status == 'PRISTINE') {
        <fa-icon icon="close" class="text-danger"></fa-icon>
      }
    </div>
  }
</div>
@if (dataCatalogStatus?.status != 'PRISTINE' && dataCatalogStatus?.lastUpdatedDate) {
  <div class="row">
    <div class="col-6">
      <strong>{{ "Template.StatusComponent.text_latestUpload" | translate }}:</strong>
    </div>
    <div class="col-6">
      <span>{{ dataCatalogStatus?.lastUpdatedDate | date : "dd.MM.yyyy, HH:mm" }} {{ "Template.StatusComponent.text_timeUnitH" | translate }}</span>
    </div>
  </div>
}
@if (dataCatalogStatus && dataCatalogStatus.status) {
  <div class="row">
    <div class="col-6">
      <strong>{{ "Template.StatusComponent.text_state" | translate }}:</strong>
    </div>
    <div class="col-6">
      @if (dataCatalogStatus.status == 'PRISTINE') {
        <span>{{ "Template.StatusComponent.text_pristine" | translate }}</span>
      }
      @if (dataCatalogStatus.status == 'UPLOADED') {
        <span>{{ "Template.StatusComponent.text_uploaded" | translate }}...</span>
      }
      @if (dataCatalogStatus.status == 'PROCESSING') {
        <span>{{ "Template.StatusComponent.text_processing" | translate }}...</span>
      }
      @if (dataCatalogStatus.status == 'CLEANING') {
        <span>{{ "Template.StatusComponent.text_cleaning" | translate }}...</span>
      }
      @if (dataCatalogStatus.status == 'DELETE_REQUESTED') {
        <span>{{ "Template.StatusComponent.text_deleteRequested" | translate }}...</span>
      }
      @if (dataCatalogStatus.status == 'DELETING') {
        <span>{{ "Template.StatusComponent.text_deleted" | translate }}...</span>
      }
      @if (dataCatalogStatus.status == 'READY') {
        <span>{{ "Template.StatusComponent.text_ready" | translate }}</span>
      }
      <span [ngbTooltip]="popContent">
        @if (dataCatalogStatus?.status == 'READY' && mediaItemsByStatus?.['NEW']?.length) {
          <fa-icon icon="spinner" animation="spin" size="1x" class="text-warning ms-2"></fa-icon>
        }
      </span>
      <ng-template #popContent> {{ mediaItemsByStatus["NEW"]?.length }} {{ "Template.StatusComponent.text_checkingMediaItems" | translate }}... </ng-template>
    </div>
  </div>
}
@if (dataCatalogStatus && dataCatalogStatus.uploadedProductCount && dataCatalogStatus.uploadedProductCount != null && dataCatalogStatus.uploadedProductCount != undefined) {
  <div class="row">
    <div class="col-6">
      <strong>{{ "Template.StatusComponent.text_uploadedProductCount" | translate }}:</strong>
    </div>
    <div class="col-6">
      {{ dataCatalogStatus.uploadedProductCount }}
    </div>
  </div>
}
@if (dataCatalogStatus && dataCatalogStatus.validProductCount != null && dataCatalogStatus.validProductCount != undefined) {
  <div class="row">
    <div class="col-6">
      <strong>{{ "Template.StatusComponent.text_validProductCount" | translate }}:</strong>
    </div>
    <div class="col-6">
      {{ dataCatalogStatus.validProductCount }}
    </div>
  </div>
}
